import { useCallback } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";

import { withoutTransitionConfirmation } from "data/history";

import { useShowNewClientCard } from "scenes/Hubly/components/HubModals/components/ClientCard/hooks";

import { useWorkDeskUrl } from "./useWorkDeskUrl";

export function useWorkDesk() {
  const history = useHistory();
  const location = useLocation();
  const { hubId } = useParams();
  const showNewClientCard = useShowNewClientCard();
  const { isClientCardPath, isWorkdeskPath, toIframePath, toParentPath } =
    useWorkDeskUrl();

  const onClientCard = isClientCardPath(location.pathname);
  const onWorkdeskPath = isWorkdeskPath(location.pathname);

  const iframePathToWorkdeskParentPath = useCallback(
    (pathname) => {
      return toParentPath(pathname, onWorkdeskPath);
    },
    [toParentPath, onWorkdeskPath]
  );

  const openWorkDesk = useCallback(() => {
    if (!hubId) {
      return;
    }
    const { pathname, search } = location;
    const from = isClientCardPath(pathname) ? pathname : `/hub/${hubId}`;

    history.replace(toParentPath(from, true) + (search || ""));
  }, [history, hubId, location, isClientCardPath, toParentPath]);

  // push (not replace) so the browser Back button can return to the
  // work desk or client the user was on; search survives both directions
  const exitWorkDesk = useCallback(() => {
    if (!hubId) {
      return;
    }
    withoutTransitionConfirmation(() => {
      history.push(`/hub/${hubId}${location.search || ""}`);
    });
  }, [history, hubId, location]);

  return {
    openWorkDesk: openWorkDesk,
    exitWorkDesk: exitWorkDesk,
    parentPathToIframePath: toIframePath,
    iframePathToWorkdeskParentPath: iframePathToWorkdeskParentPath,
    isWorkdeskClientPath: onWorkdeskPath,
    isClientCardDestination: onClientCard,
    shouldShowWorkDesk: onWorkdeskPath || (showNewClientCard && onClientCard),
    workDeskSyncEnabled: showNewClientCard || onWorkdeskPath,
  };
}

export default useWorkDesk;
